/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LogTradeValueChangeRequest } from '../models/log-trade-value-change-request';
import { VehicleFinalTradeValueTempChangeDto } from '../models/vehicle-final-trade-value-temp-change-dto';
@Injectable({
  providedIn: 'root',
})
class VehicleFinalTradeValueTempChangeClientService extends __BaseService {
  static readonly LogTradeValueChangePOSTPath = '/api/VehicleFinalTradeValueTempChange/LogTradeValueChange';
  static readonly ByIdGETPath = '/api/VehicleFinalTradeValueTempChange/{id}';
  static readonly ByIdDELETEPath = '/api/VehicleFinalTradeValueTempChange/{id}';
  static readonly GetManyGETPath = '/api/VehicleFinalTradeValueTempChange/GetMany';
  static readonly PUTPath = '/api/VehicleFinalTradeValueTempChange';
  static readonly POSTPath = '/api/VehicleFinalTradeValueTempChange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param request undefined
   */
  LogTradeValueChangePOSTResponse(request?: LogTradeValueChangeRequest): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/VehicleFinalTradeValueTempChange/LogTradeValueChange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param request undefined
   */
  LogTradeValueChangePOST(request?: LogTradeValueChangeRequest): __Observable<null> {
    return this.LogTradeValueChangePOSTResponse(request).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  ByIdGETResponse(id: number): __Observable<__StrictHttpResponse<VehicleFinalTradeValueTempChangeDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/VehicleFinalTradeValueTempChange/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VehicleFinalTradeValueTempChangeDto>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  ByIdGET(id: number): __Observable<VehicleFinalTradeValueTempChangeDto> {
    return this.ByIdGETResponse(id).pipe(
      __map(_r => _r.body as VehicleFinalTradeValueTempChangeDto)
    );
  }

  /**
   * @param id undefined
   */
  ByIdDELETEResponse(id: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/VehicleFinalTradeValueTempChange/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  ByIdDELETE(id: number): __Observable<null> {
    return this.ByIdDELETEResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param ids undefined
   * @return Success
   */
  GetManyGETResponse(ids?: Array<number>): __Observable<__StrictHttpResponse<Array<VehicleFinalTradeValueTempChangeDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (ids || []).forEach(val => {if (val != null) __params = __params.append('ids', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/VehicleFinalTradeValueTempChange/GetMany`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<VehicleFinalTradeValueTempChangeDto>>;
      })
    );
  }
  /**
   * @param ids undefined
   * @return Success
   */
  GetManyGET(ids?: Array<number>): __Observable<Array<VehicleFinalTradeValueTempChangeDto>> {
    return this.GetManyGETResponse(ids).pipe(
      __map(_r => _r.body as Array<VehicleFinalTradeValueTempChangeDto>)
    );
  }

  /**
   * @param data undefined
   */
  PUTResponse(data?: VehicleFinalTradeValueTempChangeDto): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/VehicleFinalTradeValueTempChange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param data undefined
   */
  PUT(data?: VehicleFinalTradeValueTempChangeDto): __Observable<null> {
    return this.PUTResponse(data).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param data undefined
   * @return Success
   */
  POSTResponse(data?: VehicleFinalTradeValueTempChangeDto): __Observable<__StrictHttpResponse<VehicleFinalTradeValueTempChangeDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/VehicleFinalTradeValueTempChange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VehicleFinalTradeValueTempChangeDto>;
      })
    );
  }
  /**
   * @param data undefined
   * @return Success
   */
  POST(data?: VehicleFinalTradeValueTempChangeDto): __Observable<VehicleFinalTradeValueTempChangeDto> {
    return this.POSTResponse(data).pipe(
      __map(_r => _r.body as VehicleFinalTradeValueTempChangeDto)
    );
  }
}

module VehicleFinalTradeValueTempChangeClientService {
}

export { VehicleFinalTradeValueTempChangeClientService }
